export default __webpack_public_path__ + "static/guest_card_background-5485d29b84a8942606a9c65d77d0aff1.png";